<template>
  <Popover v-if="!route.query?.print" v-slot="{ open }" class="top-0 z-50 mb-px">
    <transition enter-active-class="transition duration-300 ease-out" enter-from-class="opacity-0"
      enter-to-class="opacity-100" leave-active-class="transition duration-150 ease-in" leave-from-class="opacity-100"
      leave-to-class="opacity-0">
      <PopoverOverlay class="z-1 fixed inset-0 bg-shade-alpha-900 lg:hidden" />
    </transition>
    <div class="relative z-10 flex h-16 items-center justify-between bg-white p-4 lg:hidden">
      <MiscLogoIrcam class="h-6 hover:text-primary-400" />
      <div class="flex">
        <button @click="toogleSMobileSearch">
          <SearchIcon class="h-6 w-6 hover:text-primary-400 md:hidden" />
        </button>
        <SearchView v-show="showMobileSearch" class="md:hidden" :hide-advanced-search="true" />
        <PopoverButton class="ml-7">
          <CrossIcon v-if="open" class="h-6 w-6 hover:text-primary-400" />
          <MenuIcon v-else class="h-6 w-6 hover:text-primary-400" />
        </PopoverButton>
      </div>
    </div>
    <transition enter-active-class="transition duration-200 ease-out" enter-from-class="opacity-0"
      enter-to-class="opacity-100" leave-active-class="transition duration-150 ease-in" leave-from-class="opacity-100"
      leave-to-class="opacity-0">
      <div v-if="open" class="fixed bottom-0 top-16 h-[calc(100%-4rem)] w-full overflow-scroll">
        <PopoverPanel v-slot="{ close }" class="relative z-50 flex flex-col bg-white" static>
          <MiscLangSwitcher />
          <NavigationMenuBase @menuitem-clicked="close" />
          <NavigationMenuRoot />
        </PopoverPanel>
      </div>
      <div v-else class="hidden h-40 lg:flex lg:flex-col">
        <NavigationMenuRoot />
        <NavigationMenuBase />
      </div>
    </transition>
  </Popover>
</template>
<script lang="ts" setup>
import {
  Popover,
  PopoverButton,
  PopoverPanel,
  PopoverOverlay,
} from '@headlessui/vue'
import CrossIcon from '~/assets/icon/general/Cross.svg'
import MenuIcon from '~/assets/icon/general/Menu.svg'
import SearchIcon from '~/assets/icon/general/Search.svg'

const route = useRoute()
const showMobileSearch = ref(false)
const toogleSMobileSearch = () => {
  showMobileSearch.value = !showMobileSearch.value
}

const searchForm = ref(null)
const searchInputRef = computed(() => {
  if (!searchForm.value) return
  return searchForm.value.$refs.searchInputContainer.$refs.searchInput
})
</script>
